import { track, logError } from '@tracking';
import { NOT_SET } from '@utils/tracking/constants';
import { getSearchAsObject } from '@shared/selectors';
import getShop from '@core/reducers/shop/selectors/getShop';
import getMenu from '@core/reducers/menu/selectors/getMenu';
import getFilterMenu from '@core/reducers/menu/selectors/getFilterMenu';
import getHighlightedProducts from '@core/reducers/menu/selectors/getHighlightedProducts';
import { MENU_SECTION } from '@conversion/constants';
import { QUERY_PARAM } from '@commons/constants';
import { calcDiscount } from '@utils/number';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getShopName from '@core/reducers/shop/selectors/getShopName';
import getGlobalDiscountsWeekly from '@core/reducers/menu/selectors/getGlobalDiscountsWeekly';

const EVENT_NAME = 'product.clicked';

const trackProductClicked = ({
  product,
  clickLocation,
  menuSection = MENU_SECTION.WIDGET,
}) => (_, getState) => {
  try {
    const state = getState();
    const shop = getShop(state);
    const menu = getMenu(state);
    const filter = getFilterMenu(state);
    const search = getSearchAsObject(state);
    const products = getHighlightedProducts(state);
    const weeklyDiscount = getGlobalDiscountsWeekly(state);
    const productIsMostOrdered = false;

    const category = menu.sections.find(x =>
      x.products.some(y => y.id === product.id),
    );

    const payload = {
      shopId: getShopId(state),
      shopOpen: shop.opened === 1,
      shopClosePreorder: shop.acceptsPreOrder,
      shopName: getShopName(state),
      productSku: product.id,
      productName: product.name,
      productUnitSalePrice: calcDiscount(
        weeklyDiscount?.amount,
        product.applyDiscount,
        product.price,
      ),
      productUnitPrice: product.price,
      productCategory:
        menuSection === MENU_SECTION.REPEAT_PRODUCT
          ? menuSection
          : product.foodCategoryTag?.name || NOT_SET,
      productCategoryIndex: category?.index ? category.index + 1 : null,
      productIsMostOrdered,
      productHasPhoto: !!product.image,
      upsellingItem: NOT_SET,
      productTaxRate: product.tax?.rate || NOT_SET,
      menuSection,
      discount: weeklyDiscount?.amount,
      hasDescription: !!product.description,
      productIndex: products.findIndex(fp => fp.id === product.id) + 1,
      sectionHasPhoto: !!category?.image,
      productSearched:
        (search && search[QUERY_PARAM.SEARCH]) || filter || NOT_SET,
      productLimitQuantity: shop?.maxProductQuantity,
      clickLocation,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackProductClicked;
